import React, { useEffect, useState } from "react";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import useReveal from "../hooks/useReveal";
import { getBlogList, fileUrl } from "../api";
import { blogPosts as fallbackPosts } from "../mock";

const Blog = () => {
  const [ref, inView] = useReveal();
  const navigate = useNavigate();
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    getBlogList()
      .then((data) => setPosts(data.slice(0, 3)))
      .catch(() => setPosts(fallbackPosts.map((p, i) => ({ ...p, slug: `post-${i}`, category: "Fintech" }))));
  }, []);

  return (
    <section id="blog" className="py-20 md:py-28 bg-[#f6f9fd]">
      <div ref={ref} className="pp-container">
        <div className={`text-center pp-reveal ${inView ? "pp-in" : ""}`}>
          <span className="inline-flex items-center gap-2 text-[#06B6D4] font-semibold uppercase tracking-wider text-sm">
            <span className="w-8 h-[2px] bg-[#06B6D4]" /> Latest Post
          </span>
          <h2 className="mt-4 text-3xl md:text-5xl font-extrabold text-[#0D1B2A]">
            Our Latest <span className="pp-grad-text">Insight Blog</span>
          </h2>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-7">
          {posts.map((post, i) => (
            <article
              key={post.slug || i}
              onClick={() => post.slug && navigate(`/blog/${post.slug}`)}
              className={`group bg-white rounded-3xl overflow-hidden pp-lift border border-slate-100 cursor-pointer pp-reveal ${inView ? "pp-in" : ""}`}
              style={{ animationDelay: `${i * 0.1}s` }}
            >
              <div className="relative h-52 overflow-hidden">
                <img src={fileUrl(post.cover_image || post.image)} alt={post.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <span className="absolute top-4 left-4 bg-[#06B6D4] text-white text-[11px] font-semibold px-3 py-1 rounded-full">{post.category || "Fintech"}</span>
              </div>
              <div className="p-6">
                <h3 className="font-bold text-[#0D1B2A] leading-snug group-hover:text-[#0EA5E9] transition-colors line-clamp-3">
                  {post.title}
                </h3>
                <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-[#0EA5E9]">
                  Read More
                  <ArrowUpRight size={16} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                </span>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-10 text-center">
          <button
            onClick={() => navigate("/blog")}
            className="group inline-flex items-center gap-3 bg-[#0D1B2A] text-white font-semibold pl-7 pr-3 py-3 rounded-full hover:bg-[#06B6D4] transition-colors"
          >
            View All Articles
            <span className="w-9 h-9 rounded-full bg-white/20 flex items-center justify-center group-hover:translate-x-1 transition-transform">
              <ArrowRight size={16} />
            </span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Blog;
